import type { CardPricePoint, CardSummary } from "@hobbyshopify/backend-client";
import { Rx, RxList } from "subtree.js/core";
import { idleLoad, type LoadStatus } from "../../core/primitives/load-status";

export class PriceHistoryState {
  /** The card whose history is open, or null when the dialog is closed. */
  readonly card = new Rx<CardSummary | null>(null);
  readonly status = new Rx<LoadStatus>(idleLoad);
  /** Oldest first, as the API answers. */
  readonly prices = new RxList<CardPricePoint>();
}

export abstract class PriceHistoryActions {
  abstract open(card: CardSummary): Promise<void>;
  abstract close(): void;
}
